import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-lg" }, "Reason", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = { class: "flex flex-col w-60" }
const _hoisted_11 = { class: "flex flex-row items-center justify-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Amount:", -1)
const _hoisted_13 = { class: "uppercase" }
const _hoisted_14 = { class: "flex flex-row items-center justify-between" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Fees & taxes: ", -1)
const _hoisted_16 = { class: "uppercase" }
const _hoisted_17 = { class: "flex flex-row items-center justify-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Total:", -1)
const _hoisted_19 = { class: "uppercase" }
const _hoisted_20 = {
  key: 0,
  class: "flex flex-col bg-gray-100 rounded p-4"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Reason", -1)
const _hoisted_22 = { class: "mt-2" }
const _hoisted_23 = { class: "flex flex-col mt-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Receipts", -1)
const _hoisted_25 = { class: "flex flex-row" }
const _hoisted_26 = { class: "flex flex-wrap justify-center space-x-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-300 w-full my-6" }, null, -1)
const _hoisted_29 = { class: "flex flex-row justify-between items-center" }
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = { class: "flex flex-row items-center justify-end" }
const _hoisted_32 = {
  key: 0,
  class: "bg-red-500 rounded-full w-3 h-3 mr-3"
}
const _hoisted_33 = {
  key: 1,
  class: "bg-blue-800 rounded-full w-3 h-3 mr-3"
}
const _hoisted_34 = { class: "capitalize" }
const _hoisted_35 = { class: "text-sm mt-2" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("by ")
const _hoisted_37 = { class: "text-primary" }
const _hoisted_38 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openReason)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex flex-row items-center justify-between rounded-2xl p-4 mb-4", {
                'bg-gray-300': _ctx.reimbursement.status === 'denied',
                shadow:
                  _ctx.reimbursement.status === 'approved' ||
                  _ctx.reimbursement.status === 'paid',
              }])
                }, [
                  _createVNode(_component_UserCard, {
                    firstName: _ctx.reimbursement.user.first_name,
                    lastName: _ctx.reimbursement.user.last_name,
                    position: _ctx.reimbursement.user.job_title
                  }, null, 8, ["firstName", "lastName", "position"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.reimbursement.detail.replaceAll("_", " ")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, " $" + _toDisplayString((_ctx.reimbursement.original_amount / 100).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("span", _hoisted_16, " $" + _toDisplayString((_ctx.reimbursement.original_fee / 100).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, " $" + _toDisplayString((_ctx.reimbursement.original_total / 100).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ])
                  ])
                ], 2),
                (_ctx.reimbursement.note)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.reimbursement.note), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: i,
                          onClick: ($event: any) => (_ctx.viewReceipt(file.url)),
                          class: "mt-2 px-4 py-2 rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex align-center w-max cursor-pointer active:bg-gray-300 transition duration-300 ease"
                        }, _toDisplayString(_ctx.getFileName(file.url)), 9, _hoisted_27))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "rounded-full border-2 border-primary text-primary py-4 px-6"
                }, " Close "),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    (_ctx.reimbursement.status === 'denied')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                      : (_ctx.reimbursement.status === 'approved')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33))
                        : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.reimbursement.status), 1)
                  ]),
                  _createElementVNode("span", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.reimbursement.approver.first_name) + " " + _toDisplayString(_ctx.reimbursement.approver.last_name), 1)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openReason)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38))
      : _createCommentVNode("", true)
  ]))
}